
export default {
  data(){
    return {
      currentpage:1,
      total:0,
      data:[]
    }
  },
  created () {
    this.getdata()
  },
  methods:{
    async getdata(){
      try {
        const{data}=await this.$http.post('/shop/quotallist',{type:'telephone',page:this.currentpage,eachpage:8})
        if(data.status=='success'){
          this.data=data.data
          this.total=data.total
        }else{
          this.$message.error('获取失败')
        }
      }catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    gotobuy(id){
      this.$router.push({path:`/center/Calculatetheprice/${id}`,query:{type:'quota'}})
    }
  }
}
